import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);

  const show = useCallback((msg, type = 'success') => {
    setToast({ msg, type });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), 2800);
  }, []);

  return (
    <ToastCtx.Provider value={show}>
      {children}
      {toast && (
        <div style={{
          position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
          background: 'var(--s2)', border: '1px solid var(--border2)',
          borderRadius: 10, padding: '11px 18px',
          fontFamily: 'var(--font)', fontSize: 14, fontWeight: 600,
          boxShadow: '0 8px 40px rgba(0,0,0,.5)',
          borderLeft: `3px solid ${toast.type === 'error' ? 'var(--red)' : toast.type === 'warn' ? 'var(--amber)' : 'var(--green)'}`,
          animation: 'toastIn .22s ease',
        }}>
          {toast.msg}
        </div>
      )}
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);
